export enum RegistrationTypes {
	EARLY_BIRD,
	REGULAR,
	LATE,
}
